import React from 'react';

function AccessIcon() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="40" fill="#F9FAFB" />
      <circle cx="40" cy="40" r="21" fill="#F04438" />
      <path
        d="M40 19C34.4305 19 29.089 21.2125 25.1508 25.1508C21.2125 29.089 19 34.4305 19 40C19 45.5695 21.2125 50.911 25.1508 54.8492C29.089 58.7875 34.4305 61 40 61L40 40V19Z"
        fill="#FDA29B"
      />
      <rect x="37.0586" y="26.5586" width="5.87971" height="17.6391" rx="2.93985" fill="white" />
      <path
        d="M39.9985 26.5586C41.622 26.5586 42.9378 27.8746 42.938 29.498V41.2578C42.938 42.8814 41.6222 44.1973 39.9985 44.1973V26.5586Z"
        fill="#E4E7EC"
      />
      <circle cx="39.9986" cy="50.4986" r="2.94" fill="#E4E7EC" />
      <path
        d="M39.9986 47.5586C39.2189 47.5586 38.4711 47.8683 37.9197 48.4197C37.3683 48.9711 37.0586 49.7189 37.0586 50.4986C37.0586 51.2783 37.3683 52.0261 37.9197 52.5775C38.4711 53.1288 39.2189 53.4386 39.9986 53.4386L39.9986 50.4986V47.5586Z"
        fill="white"
      />
    </svg>
  );
}

export default AccessIcon;
